import React from "react";
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonGrid,
  IonCol,
  IonRow,
  IonImg,
  IonText,
  IonButton,
} from "@ionic/react";
import './MindMap.css';
import Logo from '../Logo';

export const MindMap = (props: { posts: any }) => {
  var date = "";
  var timestamp = "";

  var title = "";
  var abbrtitle = "";
  var newtitle = "";
  //var id = "";
  var uid = "";
  var firstname = "";
  //var lastname = "";
  var school = "";
  var statement = "";

  var observation = "";
  var communication = "";
  var collaboration = "";
  //var planning = "";
  var problemsolving = "";
  var curiosity = "";
  var responsibility = "";
  var empowerment = "";
  //var pdfPath = "https://expmindapp.wpengine.com/wp-content/uploads/pdf/";
  var pdfPath = "https://explorermindsetapp.com/wp-content/uploads/pdf/";
  var linkPath = "";

  if (props.posts.title !== undefined) {
    title = props.posts.title.replace(/[^\w\s]/gi, '');
    newtitle = title.replace(/\s+/g, ' ').trim()
    abbrtitle = newtitle.replace(/\s/g, "-").toLowerCase();

    console.log(newtitle);
    date = props.posts.date;
    timestamp = props.posts.timestamp;
    //id = props.posts.id;
    uid = props.posts.uid;
    firstname = props.posts.details.firstname;
    //lastname = props.posts.details.lastname;
    school = props.posts.details.school;
    statement = props.posts.skills.statement;

    observation = props.posts.skills.observation;
    communication = props.posts.skills.communication;
    collaboration = props.posts.skills.collaboration;
    //planning = props.posts.skills.planning;
    problemsolving = props.posts.skills.problemsolving;

    curiosity = props.posts.skills.curiosity;
    responsibility = props.posts.skills.responsibility;
    empowerment = props.posts.skills.empowerment;

    linkPath = pdfPath + abbrtitle + "_" + uid + "_" +  timestamp + ".pdf"; 
    console.log(linkPath);
  }else{
    console.log("props" + props.posts);
    console.log("title - log" + props.posts.title);
  }
  return (
<>


    <IonCard>
      <IonCardHeader>
      </IonCardHeader>
      <IonCardContent class="ion-text-start">
        <IonGrid className="mindmap">
          <IonRow>
            <IonCol>
                <Logo/>
            </IonCol>
            <IonCol style={{marginTop:'20px'}}>
                <h2>{title}</h2>
                <strong>{date}</strong>
                <p>{firstname}</p>
                {(function() {
                      if(uid  && timestamp && abbrtitle){//optional rows.
                        return(  
                          <>
                          <IonButton href={linkPath} target="_blank">Download Pdf</IonButton>
                          </>
                          );
                        
                      }else{
                        //do nothing no pdf
                      }
                })()}
            </IonCol>
            <IonCol>
                {school}
            </IonCol>
          </IonRow>
          <IonRow className="attitudes">
            <IonCol>
                <IonText className="description">{curiosity}</IonText>
                <IonImg src='../assets/images/mindmap/curiosity-image.jpg' className="icons"/>
            </IonCol>
            <IonCol>
                <IonText className="description">{responsibility}</IonText>
                <IonImg src='../assets/images/mindmap/responsibility-image.jpg' className="icons"/>
            </IonCol>
            <IonCol>
              <IonText className="description">{empowerment}</IonText>
              <IonImg src='../assets/images/mindmap/empowerment-image.jpg' className="icons"/>
            </IonCol>
          </IonRow>
          <IonCol>
            <IonRow className="mainstatement" style={{textAlign:'center'}}>
              {statement}
            </IonRow>
          </IonCol>
          <IonRow className="skills">
            <IonCol>
              <IonImg src="../assets/images/mindmap/observation-image.jpg" className="icons"/>
              <IonText className="description">{observation}</IonText>
            </IonCol>
            <IonCol>
              <IonImg src="../assets/images/mindmap/communication-image.jpg" className="icons"/>
              <IonText className="description">{communication}</IonText>
            </IonCol>
            <IonCol>
              <IonImg src="../assets/images/mindmap/collaboration-image.jpg" className="icons"/>
              <IonText className="description">{collaboration}</IonText>
            </IonCol>
            <IonCol className="mindmapbox">
            <IonImg src="../assets/images/mindmap/problem-solving-image.jpg" className="icons"/>
              <IonText className="description">{problemsolving}</IonText>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>

<IonButton onClick={() => document?.querySelector("ion-content")?.scrollToTop(500) } style={{marginLeft:'40px'}}>Top</IonButton>
</>
  );
};
